import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ShieldAlert, UserMinus, ShoppingBasket } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Skeleton } from "@/components/ui/skeleton";
import { PageHeader } from "@/components/PageHeader";
import { api, errMsg } from "@/lib/api";
import { SuspectTab } from "@/components/cards/SuspectTab";
import { AbsentTab } from "@/components/cards/AbsentTab";
import { BasketTab } from "@/components/cards/BasketTab";
import { toast } from "sonner";

export default function KpiCards() {
  const [cfg, setCfg] = useState(null);
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "suspect";
  useEffect(() => { api.get("/cards/config").then((r) => setCfg(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const saveCfg = async (next) => {
    try { const r = await api.put("/cards/config", next); setCfg(r.data); } catch (e) { toast.error(errMsg(e)); throw e; }
  };

  return (
    <div>
      <PageHeader title="KPI Carte" subtitle="Carte sospette, carte assenti e carte per paniere prodotti: parametri definibili, export e segmenti" />
      {!cfg ? <Skeleton className="h-64" /> : (
        <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })}>
          <TabsList className="mb-6 flex-wrap">
            <TabsTrigger value="suspect" data-testid="cards-tab-suspect"><ShieldAlert className="mr-1.5 h-4 w-4" />Carte sospette</TabsTrigger>
            <TabsTrigger value="absent" data-testid="cards-tab-absent"><UserMinus className="mr-1.5 h-4 w-4" />Carte assenti</TabsTrigger>
            <TabsTrigger value="basket" data-testid="cards-tab-basket"><ShoppingBasket className="mr-1.5 h-4 w-4" />Carte paniere prodotti</TabsTrigger>
          </TabsList>
          <TabsContent value="suspect"><SuspectTab cfg={cfg} saveCfg={saveCfg} /></TabsContent>
          <TabsContent value="absent"><AbsentTab cfg={cfg} saveCfg={saveCfg} /></TabsContent>
          <TabsContent value="basket"><BasketTab cfg={cfg} saveCfg={saveCfg} /></TabsContent>
        </Tabs>)}
    </div>
  );
}
